import React from 'react';
import clsx from 'clsx';
import BlockTitleGroup from '../block-title-group';
import {useStyles} from './helpers';

const BlockSumBonus = ({formik, promocode, weekly, registration}) => {
    const [sumBonus, setSumBonus] = React.useState(false);
    const classes = useStyles();

    return (
        <div>
            <BlockTitleGroup setShowBlock={setSumBonus} showBlock={sumBonus} title="Сумма бонуса" />
            {
                sumBonus &&
                <>
                    {
                        promocode &&
                        <>
                            <label htmlFor="promocode" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                                <span className={classes.helper}>Промокод</span>
                                <input 
                                    type="text" 
                                    name="promocode" 
                                    id="promocode" 
                                    className={classes.text}
                                    value={formik.values.promocode} 
                                    onChange={(v) => formik.setFieldValue('promocode', v.target.value)}
                                />
                            </label>
                        </>
                    }
                    {
                        weekly && 
                        <>
                        <select 
                            id="day" 
                            name="day" 
                            className={classes.select}
                            value={formik.values.day} 
                            onChange={(v) => formik.setFieldValue('day', v.target.value)}
                        >
                            <option value="Понедельник">Понедельник</option>
                            <option value="Вторник">Вторник</option>
                            <option value="Среда">Среда</option>
                            <option value="Четверг">Четверг</option>
                            <option value="Пятница">Пятница</option>
                            <option value="Суббота">Суббота</option>
                            <option value="Воскресенье">Воскресенье</option>
                        </select>
                        </>
                    }
                    <label htmlFor="fix_size_bonus" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                        <span className={classes.helper}>Фиксированный размер бонуса</span>
                        <input 
                            type="number" 
                            name="fix_size_bonus" 
                            id="fix_size_bonus" 
                            className={classes.text}
                            value={formik.values.fix_size_bonus} 
                            onChange={(v) => formik.setFieldValue('fix_size_bonus', v.target.value)}
                        />
                    </label>
                    <label htmlFor="wager" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                        <span className={classes.helper}>Коэффициент для фиксированного бонуса</span>
                        <input 
                            type="number" 
                            name="wager" 
                            id="wager" 
                            className={classes.text} 
                            value={formik.values.wager} 
                            onChange={(v) => formik.setFieldValue('wager', v.target.value)}/>
                    </label>
                </>
            }
        </div>
    )
}

export default BlockSumBonus;